var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import clsassnames from 'classnames';
import { install, ResizeObserver } from 'resize-observer';
if (!ResizeObserver) {
    install();
}
var SCROLL_BAR_WIDTH = 17;
var SimpleScroller = (function (_super) {
    __extends(SimpleScroller, _super);
    function SimpleScroller(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollHeight = 0;
        _this.saveRef = function (key) { return function (ref) { _this[key] = ref; }; };
        _this.handleMouseWheel = function (evtRaw) {
            var evt = evtRaw || window.event;
            var onWheel = _this.props.onWheel;
            if (typeof onWheel === 'function') {
                onWheel(evt);
            }
            var scrollDom = _this.scrollContentDom;
            var canScrollY = scrollDom.clientHeight < scrollDom.scrollHeight;
            var canScrollX = scrollDom.clientWidth < scrollDom.scrollWidth;
            if (!canScrollY && !canScrollX) {
                return;
            }
            var toLeft = scrollDom.scrollLeft === 0 && evt.deltaX < 0;
            var toTop = scrollDom.scrollTop === 0 && evt.deltaY < 0;
            var toBottom = scrollDom.scrollTop + scrollDom.clientHeight >= scrollDom.scrollHeight && evt.deltaY > 0;
            var toRight = scrollDom.scrollLeft + scrollDom.clientWidth >= scrollDom.scrollWidth && evt.deltaX > 0;
            if (canScrollY && (toTop || toBottom)) {
                return;
            }
            if (canScrollX && (toLeft || toRight)) {
                return;
            }
            evt.preventDefault();
            evt.stopPropagation();
            scrollDom.scrollTo(scrollDom.scrollLeft + evt.deltaX, scrollDom.scrollTop + evt.deltaY);
        };
        _this.handleMouseDown = function (evtRaw) {
            var evt = evtRaw || window.event;
            evt.stopPropagation();
            var thumbY = _this.scrollbarDom.firstChild;
            var thumbX = _this.scrollbarDomHorizontal.firstChild;
            _this.setState({ mouseDown: true });
            if (evt.target === thumbY || evt.target === thumbX) {
                var left = thumbX.getBoundingClientRect().left - evt.clientX;
                var top_1 = thumbY.getBoundingClientRect().top - evt.clientY;
                _this.mouseThumbOffset = { left: left, top: top_1 };
                return;
            }
            else {
                _this.mouseThumbOffset = {
                    left: -thumbX.clientWidth / 2,
                    top: -thumbY.clientHeight / 2,
                };
            }
            _this.updateScrollConent(evt, 'smooth');
        };
        _this.onScroll = function () {
            requestAnimationFrame(function () {
                _this.updateScrollBar();
                _this.handleScroll();
            });
        };
        _this.handleScroll = function () {
            var scrollDom = _this.scrollContentDom;
            if (_this.props.onScroll) {
                _this.props.onScroll({
                    top: scrollDom.scrollTop,
                    left: scrollDom.scrollLeft,
                    scrollDom: scrollDom,
                });
            }
            if (scrollDom.scrollTop === 0) {
                _this.props.onTop();
            }
            else if (scrollDom.scrollTop + scrollDom.getBoundingClientRect().height >= scrollDom.scrollHeight) {
                _this.props.onBottom();
            }
            _this.lastScrollHeight = scrollDom.scrollHeight;
        };
        _this.handleMouseMove = function (e) {
            if (_this.state.mouseDown) {
                e.stopPropagation();
                e.preventDefault();
                requestAnimationFrame(function () {
                    _this.updateScrollConent(e);
                });
            }
        };
        _this.updateScrollBar = function () {
            var _a = _this, scrollbarDom = _a.scrollbarDom, scrollContentDom = _a.scrollContentDom, scrollbarDomHorizontal = _a.scrollbarDomHorizontal, selfDom = _a.selfDom;
            if (!_this.props.customScrollBar || !scrollbarDom || !scrollContentDom) {
                return;
            }
            var scrollBarWidth = _this.props.customScrollBar ? 0 : SCROLL_BAR_WIDTH;
            if (scrollContentDom.scrollHeight <= (scrollContentDom.clientHeight + 20)) {
                scrollbarDom.classList.add('none');
                scrollContentDom.style.width = selfDom.clientWidth + 'px';
            }
            else {
                scrollbarDom.classList.remove('none');
                scrollContentDom.style.width = selfDom.clientWidth + scrollBarWidth + 'px';
            }
            if (scrollContentDom.scrollWidth <= (scrollContentDom.clientWidth + 20)) {
                scrollbarDomHorizontal.classList.add('none');
                scrollContentDom.style.height = selfDom.clientHeight + 'px';
            }
            else {
                scrollbarDomHorizontal.classList.remove('none');
                scrollContentDom.style.height = selfDom.clientHeight + scrollBarWidth + 'px';
            }
            _this.updateThumbSize();
            _this.updateThumbHorizontalSize();
        };
        _this.updateThumbSize = function () {
            var _a = _this, scrollbarDom = _a.scrollbarDom, scrollContentDom = _a.scrollContentDom;
            var thumb = scrollbarDom.firstElementChild;
            if (!thumb) {
                return;
            }
            var thumbHeight = (scrollContentDom.clientHeight / scrollContentDom.scrollHeight * scrollbarDom.clientHeight);
            thumbHeight = Math.max(Math.round(thumbHeight), 20);
            thumb.style.height = thumbHeight + 'px';
            var scrollableHeight = scrollContentDom.scrollHeight - scrollContentDom.clientHeight;
            thumb.style.top = ((scrollContentDom.scrollTop / scrollableHeight) * (scrollbarDom.clientHeight - thumbHeight)) + 'px';
        };
        _this.updateThumbHorizontalSize = function () {
            var _a = _this, scrollbarDom = _a.scrollbarDomHorizontal, scrollContentDom = _a.scrollContentDom;
            var thumb = scrollbarDom.firstElementChild;
            if (!thumb) {
                return;
            }
            var thumbWidth = (scrollContentDom.clientWidth / scrollContentDom.scrollWidth * scrollbarDom.clientWidth);
            thumbWidth = Math.max(Math.round(thumbWidth), 20);
            thumb.style.width = thumbWidth + 'px';
            var scrollableWidth = scrollContentDom.scrollWidth - scrollContentDom.clientWidth;
            thumb.style.left = ((scrollContentDom.scrollLeft / scrollableWidth) * (scrollbarDom.clientWidth - thumbWidth)) + 'px';
        };
        _this.scrollToBottom = function () {
            var scrollContentDom = _this.scrollContentDom;
            scrollContentDom.scrollTop = scrollContentDom.scrollHeight;
        };
        _this.scrollToLastHeight = function () {
            _this.scrollContentDom.scrollTop = _this.scrollContentDom.scrollHeight - _this.lastScrollHeight;
        };
        _this.updateScrollConent = function (_a, behavior) {
            var clientX = _a.clientX, clientY = _a.clientY;
            if (behavior === void 0) { behavior = 'auto'; }
            var top = _this.getContentTopOffset(clientY);
            var left = _this.getContentLeftOffset(clientX);
            _this.scrollContentDom.scrollTo({
                left: left,
                top: top,
                behavior: behavior,
            });
        };
        _this.getContentTopOffset = function (clientY) {
            var _a = _this, scrollbarDom = _a.scrollbarDom, scrollContentDom = _a.scrollContentDom;
            if (scrollContentDom.scrollHeight <= scrollContentDom.clientHeight) {
                return 0;
            }
            var thumb = scrollbarDom.firstElementChild;
            if (!thumb) {
                return;
            }
            var trackRect = scrollbarDom.getBoundingClientRect();
            var mouseTop = clientY + _this.mouseThumbOffset.top - trackRect.top;
            var percentY = (mouseTop) / (scrollbarDom.clientHeight - thumb.clientHeight);
            percentY = Math.max(0, percentY);
            var scrollableHeight = scrollContentDom.scrollHeight - scrollContentDom.clientHeight;
            return percentY * scrollableHeight;
        };
        _this.getContentLeftOffset = function (clientX) {
            var _a = _this, scrollbarDomHorizontal = _a.scrollbarDomHorizontal, scrollContentDom = _a.scrollContentDom;
            if (scrollContentDom.scrollWidth <= scrollContentDom.clientWidth) {
                return 0;
            }
            var thumb = scrollbarDomHorizontal.firstElementChild;
            if (!thumb) {
                return;
            }
            var trackRect = scrollbarDomHorizontal.getBoundingClientRect();
            var mouseLeft = clientX + _this.mouseThumbOffset.left - trackRect.left;
            var percentX = (mouseLeft) / (scrollbarDomHorizontal.clientWidth - thumb.clientWidth);
            percentX = Math.max(0, percentX);
            var scrollableHeight = scrollContentDom.scrollWidth - scrollContentDom.clientWidth;
            return percentX * scrollableHeight;
        };
        _this.state = {
            mouseDown: false,
        };
        return _this;
    }
    SimpleScroller.prototype.componentDidMount = function () {
        if (this.props.customScrollBar) {
            this.bindScrollbarEvent();
            this.updateScrollBar();
        }
    };
    SimpleScroller.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.customScrollBar && this.props.children !== prevProps.children) {
            this.updateScrollBar();
        }
    };
    SimpleScroller.prototype.componentWillUnmount = function () {
        if (this.ro) {
            this.ro.unobserve(this.selfDom);
        }
    };
    SimpleScroller.prototype.bindScrollbarEvent = function () {
        var _this = this;
        var setMouseDownThunk = function (mouseDown) {
            return function () { return _this.setState({ mouseDown: mouseDown }); };
        };
        var customWheel = this.props.customWheel;
        this.scrollbarDom.onmousedown = this.handleMouseDown;
        this.scrollbarDomHorizontal.onmousedown = this.handleMouseDown;
        this.selfDom.onmousemove = this.handleMouseMove;
        this.selfDom.onmouseleave = setMouseDownThunk(false);
        this.selfDom.onmouseup = setMouseDownThunk(false);
        if (customWheel) {
            this.selfDom.onwheel = this.handleMouseWheel;
        }
        this.ro = new ResizeObserver(function () {
            requestAnimationFrame(_this.updateScrollBar);
        });
        this.ro.observe(this.selfDom);
    };
    SimpleScroller.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, customScrollBar = _a.customScrollBar, customMouseWheel = _a.customWheel, displayScrollbar = _a.displayScrollbar, style = _a.style;
        var mouseDown = this.state.mouseDown;
        var classNameMap = {
            'custom-scroll-bar': customScrollBar,
            'custom-mouse-wheel': customMouseWheel,
            'active': mouseDown,
            'hover': displayScrollbar,
        };
        return (React.createElement("div", { ref: this.saveRef('selfDom'), className: clsassnames('simple-scroller', className, classNameMap), onScroll: this.onScroll, style: style },
            React.createElement("div", { className: "scroll-content", ref: this.saveRef('scrollContentDom') }, children),
            customScrollBar && (React.createElement("div", { className: "scrollbar-track", ref: this.saveRef('scrollbarDom') },
                React.createElement("div", { className: "scrollbar-thumb" }))),
            customScrollBar && (React.createElement("div", { className: "scrollbar-track horizontal", ref: this.saveRef('scrollbarDomHorizontal') },
                React.createElement("div", { className: "scrollbar-thumb horizontal" })))));
    };
    SimpleScroller.defaultProps = {
        onTop: function () { return; },
        onBottom: function () { return; },
        className: '',
        customScrollBar: false,
        style: {},
    };
    return SimpleScroller;
}(React.Component));
export default SimpleScroller;

//# sourceMappingURL=index.js.map
